<template>
  <div style="background: #fff; width: 100%">
    <HelpPop ref="HelpPop" :RMSSD="info.beforeRMSSD"></HelpPop>
    <!-- 头部 -->
    <!-- <HeaderModel></HeaderModel> -->

    <div class="health-report-page" v-if="info.id">
      <!-- 顶部导航 -->
      <div class="top-nav">
        <div class="back-home" @click="goBack">
          <img
            class="back-icon"
            src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-11login3.png"
            alt=""
          />
          <span>返回首页</span>
        </div>
      </div>

      <div ref="cardRef" class="cardRef">
        <!-- 页面标题 -->
        <h1 class="page-title">您的健康状态快照</h1>
        <p class="disclaimer">
          受数据采集时环境光线、人体晃动或其他外部因素干扰，相应测量数据及分析解读可能存在偏差，仅供参考
        </p>

        <!-- 心脏健康得分卡片 -->
        <div class="score-card">
          <div class="score-label">心脏健康得分</div>
          <div class="score-value">
            <span class="score-number">{{ info.score }}</span>
            <span class="score-unit">分</span>
            <img
              class="info-icon"
              @click="$refs.HelpPop.open(1)"
              src="@/static/3-12Eff1.png"
              alt=""
            />
          </div>
          <div class="score-badge">
            <img class="star-icon" src="@/static/3-12Eff2.png" alt="" />
            <span>超越全球{{ info.beforeHealthRatio }}%用户</span>
          </div>
        </div>

        <!-- 数据卡片网格 -->
        <div class="data-grid">
          <div class="data-card">
            <div class="data-value">{{ info.beforeBpm }}</div>
            <div class="data-label">
              实时心率 (BPM)
              <img
                class="info-icon-small"
                @click="$refs.HelpPop.open(4)"
                src="@/static/3-12Eff3.png"
                alt=""
              />
            </div>
            <div
              class="data-status normal1"
              v-if="info.beforeBpm >= 50 && info.beforeBpm <= 110"
            >
              正常范围
            </div>
            <div
              class="data-status normal2"
              v-else-if="
                (info.beforeBpm >= 40 && info.beforeBpm < 50) ||
                (info.beforeBpm > 110 && info.beforeBpm <= 120)
              "
            >
              需要关注
            </div>
            <div class="data-status normal3" v-else-if="info.beforeBpm">
              需要关注
            </div>
          </div>

          <div class="data-card">
            <div class="data-value">{{ info.beforeRMSSD }}</div>
            <div class="data-label">
              HRV 健康指数
              <img
                class="info-icon-small"
                @click="$refs.HelpPop.open(2)"
                src="@/static/3-12Eff3.png"
                alt=""
              />
            </div>
            <div class="data-status normal1" v-if="info.beforeRMSSD > 50">
              优秀
            </div>
            <div class="data-status normal1" v-else-if="info.beforeRMSSD > 30">
              良好
            </div>
            <div class="data-status normal2" v-else-if="info.beforeRMSSD > 20">
              一般
            </div>
            <div class="data-status normal3" v-else-if="info.beforeRMSSD > 15">
              较低
            </div>
            <div class="data-status normal3" v-else>较差</div>
          </div>

          <div class="data-card">
            <div class="data-value">{{ info.beforePressure }}</div>
            <div class="data-label">
              压力水平
              <img
                class="info-icon-small"
                @click="$refs.HelpPop.open(5)"
                src="@/static/3-12Eff3.png"
                alt=""
              />
            </div>
            <div class="data-status normal1" v-if="info.beforePressure <= 30">
              极低压力
            </div>
            <div
              class="data-status normal2"
              v-else-if="info.beforePressure <= 60"
            >
              中度压力
            </div>
            <div class="data-status normal3" v-else>高压力</div>
          </div>

          <div class="data-card">
            <div class="data-value">{{ info.beforeBreathingRate }}</div>
            <div class="data-label">
              呼吸率 (次/分钟)
              <img
                class="info-icon-small"
                @click="$refs.HelpPop.open(3)"
                src="@/static/3-12Eff3.png"
                alt=""
              />
            </div>
            <div
              class="data-status normal1"
              v-if="
                info.beforeBreathingRate >= 12 && info.beforeBreathingRate <= 20
              "
            >
              正常范围
            </div>
            <div class="data-status normal3" v-else>需要关注</div>
          </div>
        </div>

        <!-- 个性化健康建议 -->
        <div class="advice-card" v-if="info.score || info.score === 0">
          <h2 class="advice-title">个性化健康建议</h2>
          <p class="advice-disclaimer">
            本建议基于您的分值生成，仅用于日常健康管理参考，不具有医疗诊断、治疗或预防疾病的效力。若有明显不适，请务必及时就医。在使用本软件及相关硬件设备前，建议咨询专业医生。
          </p>
          <div class="advice-list">
            <div class="advice-item" v-for="(item, index) in 4" :key="index">
              <img class="advice-icon" src="@/static/3-12Eff4.png" alt="" />
              <span>{{ list[listIndex][index] }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 底部按钮组 -->
      <div class="button-group">
        <button class="btn-download" @click="handleDownloadReport">
          <img class="download-icon" src="@/static/3-12Eff5.png" alt="" />
          <span>下载报告</span>
        </button>
        <button class="btn-recapture" @click="handleRecapture">
          <img class="refresh-icon" src="@/static/3-12Eff6.png" alt="" />
          <span>再次采集</span>
        </button>
      </div>
    </div>
    <!-- 页脚 -->
    <FooterModel v-if="info.id"></FooterModel>
  </div>
</template>

<script>
import { report } from "@/api/index";
import HelpPop from "@/components/HelpPop.vue";
import HeaderModel from "@/components/HeaderModel.vue";
import FooterModel from "@/components/FooterModel.vue";
// 引入依赖
import domtoimage from "dom-to-image-more";
import { saveAs } from "file-saver";

export default {
  name: "HealthReport",
  components: {
    FooterModel,
    HeaderModel,
    HelpPop,
  },
  data() {
    return {
      list: [
        [
          "建议继续保持当前健康的生活节奏，维持适度的日常运动。",
          "坚持使用 ta-VNS 安睡仪，结合不同身体状态，使用相应模式。",
          "建议每日进行 10 分钟正念冥想，提升副交感神经活性，保持身心放松。",
          "保持充足睡眠（建议 7-8 小时），规律作息有助于心脏功能的自我修复。",
        ],
        [
          "建议适当优化日常作息，避免过度劳累，可进行规律的有氧锻炼。",
          "坚持使用 ta-VNS 安睡仪，结合不同身体状态，使用相应模式。",
          "建议每日进行 10 分钟正念冥想，提升副交感神经活性，缓解日常压力。",
          "保持充足睡眠（建议 7-8 小时），规律作息有助于心脏功能的自我修复。",
        ],
        [
          "建议主动改善生活方式，减少熬夜与久坐，增加轻量化的日常活动。",
          "坚持使用 ta-VNS 安睡仪，结合不同身体状态，使用相应模式。",
          "建议每日进行 10 分钟正念冥想，提升副交感神经活性，辅助调节身心平衡。",
          "保持充足睡眠（建议 7-8 小时），规律作息有助于心脏功能的自我修复。",
        ],
        [
          "建议咨询专业医生，获取针对性的健康评估，并在指导下安排日常活动。",
          "坚持使用 ta-VNS 安睡仪，结合不同身体状态，使用相应模式。",
          "建议每日进行 10 分钟正念冥想，提升副交感神经活性，降低机体应激反应。",
          "优先保证睡眠时间与质量，充足的休息是身体修复的重要基础。",
        ],
      ],
      info: {},
    };
  },
  computed: {
    listIndex() {
      let score = this.info.score;
      if (score == null) return 0;
      if (score < 60) return 3;
      if (score < 70) return 2;
      if (score < 80) return 1;
      return 0;
    },
  },
  mounted() {
    // this.$refs.HelpPop.open(5)
    this.getInfo();
  },
  methods: {
    async getInfo() {
      // this.$loading.open("加载中...");
      try {
        await report({ id: JSON.parse(localStorage.getItem("id")) }).then(
          (res) => {
            this.info = res.baseInfo;
          }
        );
      } catch (err) {
        this.$toast.error(err.msg);
      }
    },
    goBack() {
      this.$router.replace("/");
    },
    async _waitForResources(element) {
      // 1. 等待 Vue 渲染完成
      await this.$nextTick();

      // 2. 等待字体加载（关键！）
      if (document.fonts?.ready) {
        await document.fonts.ready;
      }

      // 3. 等待所有图片加载
      const images = element.querySelectorAll("img");
      if (images.length > 0) {
        await Promise.all(
          Array.from(images).map((img) => {
            if (img.complete && img.naturalHeight !== 0)
              return Promise.resolve();
            return new Promise((resolve) => {
              img.onload = resolve;
              img.onerror = resolve; // 加载失败也继续
            });
          })
        );
      }

      // 4. 额外缓冲 + 强制重排
      await new Promise((resolve) => setTimeout(resolve, 150));
      element.offsetHeight; // 触发 reflow
    },
    /**
     * 下载报告
     * 生成 PDF 或图片格式的健康报告供用户下载
     */
    async handleDownloadReport() {
      const el = this.$refs.cardRef;
      if (!el) return;

      await this._waitForResources(el);

      try {
        const dataUrl = await domtoimage.toPng(el, {
          bgcolor: "#ffffff",
          scale: 2,
          width: el.offsetWidth,
          height: el.offsetHeight,
          style: {
            transform: "none",
            margin: "0",
            padding: "3rem",
            position: "relative",
          },
        });

        // ==============================================
        // 👇 这一段是【手机保存到相册】的核心代码
        // ==============================================
        if (this.isMobile()) {
          // 手机端：保存到相册
          const link = document.createElement("a");
          link.href = dataUrl;
          link.download = `健康报告_${Date.now()}.png`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

        } else {
          // PC 端：正常下载
          const blob = await fetch(dataUrl).then((r) => r.blob());
          saveAs(blob, `健康报告_${Date.now()}.png`);
        }
      } catch (e) {
        console.error("生成失败", err);
      }
    },

    // 判断是否是手机端
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
    /**
     * 再次采集
     * 跳转到数据采集页面重新测量
     */
    handleRecapture() {
      this.$router.replace("/IntendCollect");
    },
  },
};
</script>

<style lang="scss" scoped>
@media all and (min-width: 768px) {
  .health-report-page {
    min-height: 100vh;
    width: 100%;
    background: #fff;
    padding: 2rem;
    padding-top: 4rem;
    box-sizing: border-box;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      sans-serif;
    // max-width: 68.75rem;
    margin: 0 auto;
    .cardRef {
      width: 75rem;
      margin: auto;
      padding: 3rem 0rem;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
    }

    .top-nav {
      width: 68.75rem;
      margin: 0 auto;
      margin-bottom: 2rem;

      .back-home {
        display: flex;
        align-items: center;
        color: #4e5361;
        font-size: 1.25rem;
        font-weight: 500;
        cursor: pointer;
        user-select: none;

        .back-icon {
          width: 1.625rem;
          height: 1.625rem;
          margin-right: 1.1rem;
        }
      }
    }

    .page-title {
      font-weight: bold;
      font-size: 3.5rem;
      color: #101424;
      text-align: center;
      margin-bottom: 1rem;
    }

    .disclaimer {
      font-size: 1.25rem;
      color: #666;
      text-align: center;
      margin-bottom: 2.5rem;
      line-height: 1.6;
      max-width: 70rem;
      margin-left: auto;
      margin-right: auto;
    }

    .score-card {
      width: 68.75rem;
      margin: auto;
      background: linear-gradient(135deg, #66b3ff 0%, #0074fc 100%);
      border-radius: 1.25rem;
      padding: 2.5rem;
      text-align: center;
      margin-bottom: 1.5rem;
      color: #ffffff;

      .score-label {
        font-size: 1.125rem;
        margin-bottom: 1rem;
        opacity: 0.9;
      }

      .score-value {
        display: flex;
        align-items: baseline;
        justify-content: center;
        margin-bottom: 1rem;

        .score-number {
          font-size: 4rem;
          font-weight: bold;
          // margin-left: 3.5rem;
        }

        .score-unit {
          font-size: 1.5rem;
          margin-left: 0.5rem;
        }

        .info-icon {
          width: 1.25rem;
          height: 1.25rem;
          margin-left: 0.5rem;
          cursor: pointer;
          opacity: 0.8;
        }
      }

      .score-badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background: rgba(255, 255, 255, 0.2);
        border: 1px solid rgba(255, 255, 255, 0.3);
        border-radius: 2rem;
        height: 3rem;
        box-sizing: border-box;
        padding: 0.5rem 1.25rem;
        font-size: 1.125rem;
        /* 核心：强制不换行 */
        white-space: nowrap !important;
        /* 防止文字被拆分换行（中文场景） */
        word-break: keep-all !important;
        .star-icon {
          width: 1rem;
          height: 1rem;
          margin-right: 0.5rem;
        }
      }
    }

    .data-grid {
      width: 68.75rem;
      margin: 0 auto;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 1rem;
      margin-bottom: 1.5rem;

      .data-card {
        background: #ffffff;
        border: 1px solid #e5e5e7;
        border-radius: 1rem;
        padding: 2rem 1.5rem;
        text-align: center;
        box-shadow: 0 0.25rem 1rem rgba(0, 0, 0, 0.05);

        .data-value {
          font-size: 3rem;
          font-weight: bold;
          color: #0074fc;
          margin-bottom: 0.75rem;
        }

        .data-label {
          font-size: 1.125rem;
          color: #666;
          margin-bottom: 0.75rem;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.25rem;
          /* 核心：强制不换行 */
          white-space: nowrap !important;
          /* 防止文字被拆分换行（中文场景） */
          word-break: keep-all !important;

          .info-icon-small {
            cursor: pointer;
            width: 1rem;
            height: 1rem;
            opacity: 0.6;
          }
        }

        .data-status {
          display: inline-block;
          width: 10rem;
          height: 3rem;
          line-height: 3rem;
          text-align: center;
          font-size: 1.125rem;
          border-radius: 1.75rem;

          &.normal1 {
            background: #73d13e1a;
            color: #73d13e;
          }
          &.normal2 {
            background: #0074fc1a;
            color: #0074fc;
          }
          &.normal3 {
            background: #faad141a;
            color: #faad14;
          }
        }
      }
    }

    .advice-card {
      width: 68.75rem;
      margin: 0 auto;
      background: linear-gradient(135deg, #66b3ff 0%, #0074fc 100%);
      border-radius: 1.25rem;
      padding: 2rem;
      margin-bottom: 1.5rem;
      color: #ffffff;

      .advice-title {
        font-size: 1.25rem;
        font-weight: 600;
        margin-bottom: 1rem;
      }

      .advice-disclaimer {
        font-size: 1.125rem;
        line-height: 1.6;
        opacity: 0.8;
        margin-bottom: 1.5rem;
      }

      .advice-list {
        .advice-item {
          display: flex;
          align-items: center;
          justify-content: left;
          // align-items: anchor-center;
          background: rgba(255, 255, 255, 0.15);
          border-radius: 0.5rem;
          padding: 1rem;
          margin: auto;
          margin-bottom: 0.75rem;
          font-size: 1.125rem;
          line-height: 1.6;
          /* 核心：强制不换行 */
          white-space: nowrap !important;
          /* 防止文字被拆分换行（中文场景） */
          word-break: keep-all !important;

          .advice-icon {
            width: 1.25rem;
            height: 1.25rem;
            margin-right: 0.75rem;
            flex-shrink: 0;
          }
        }
      }
    }

    .button-group {
      width: 68.75rem;
      margin: 0 auto;
      margin-bottom: 5rem;
      display: flex;
      gap: 1rem;

      .btn-download {
        flex: 1;
        height: 3.5rem;
        background: #0074fc;
        border: none;
        border-radius: 0.75rem;
        color: #ffffff;
        font-size: 1.125rem;
        font-weight: 500;
        cursor: pointer;
        transition: background 0.2s;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;

        .download-icon {
          width: 1.25rem;
          height: 1.25rem;
        }

        &:hover {
          background: #0066e0;
        }

        &:active {
          background: #0058c0;
        }
      }

      .btn-recapture {
        flex: 1;
        height: 3.5rem;
        background: #e8f4ff;
        border: none;
        border-radius: 0.75rem;
        color: #0074fc;
        font-size: 1.125rem;
        font-weight: 500;
        cursor: pointer;
        transition: background 0.2s;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;

        .refresh-icon {
          width: 1.25rem;
          height: 1.25rem;
        }

        &:hover {
          background: #d0e8ff;
        }

        &:active {
          background: #b8dcff;
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .health-report-page {
    min-height: 100vh;
    width: 100%;
    background: #f5f6fe;
    padding-bottom: 2rem;
    box-sizing: border-box;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      sans-serif;
    margin: 0 auto;
    .cardRef {
      width: 46.875rem;
      margin: auto;
      padding: 3rem 0rem 1.5rem;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
    }

    .top-nav {
      width: 42.375rem;
      margin: 0 auto;
      margin-bottom: 2rem;

      .back-home {
        width: 42.375rem;
        margin: auto;
        padding-top: 4rem;
        display: flex;
        align-items: center;
        color: #4e5361;
        font-weight: 600;
        font-size: 1.75rem;
        cursor: pointer;
        user-select: none;

        .back-icon {
          width: 2.25rem;
          height: 2.25rem;
          margin-right: 1.1rem;
          object-fit: contain;
        }
      }
    }

    .page-title {
      font-weight: bold;
      font-size: 3rem;
      color: #101424;
      text-align: center;
      margin-bottom: 1rem;
    }

    .disclaimer {
      font-size: 1.75rem;
      color: #666;
      text-align: center;
      margin-bottom: 2.5rem;
      line-height: 1.6;
      max-width: 70rem;
      margin-left: auto;
      margin-right: auto;
      padding: 0rem 2rem;
    }

    .score-card {
      width: 42.375rem;
      margin: auto;
      background: linear-gradient(135deg, #66b3ff 0%, #0074fc 100%);
      border-radius: 1.5rem;
      padding: 5rem 2.5rem;
      text-align: center;
      margin-bottom: 1.5rem;
      color: #ffffff;

      .score-label {
        font-size: 2rem;
        margin-bottom: 1rem;
        opacity: 0.9;
      }

      .score-value {
        display: flex;
        // align-items: baseline;
        justify-content: center;
        height: 10rem;
        margin-bottom: 1rem;

        .score-number {
          font-size: 6.5rem;
          font-weight: bold;
          // margin-left: 6.5rem;
        }

        .score-unit {
          font-size: 2.5rem;
          margin-left: 0.5rem;
          line-height: 12.5rem;
        }

        .info-icon {
          width: 2.5rem;
          height: 2.5rem;
          margin-left: 0.8rem;
          margin-top: 5rem;
          cursor: pointer;
          opacity: 0.8;
        }
      }

      .score-badge {
        width: 26.25rem;
        height: 6.5rem;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        background: rgba(255, 255, 255, 0.2);
        border: 1px solid rgba(255, 255, 255, 0.3);
        border-radius: 6.4rem;
        padding: 0.5rem 1.25rem;
        font-size: 2rem;
        /* 核心：强制不换行 */
        white-space: nowrap !important;
        /* 防止文字被拆分换行（中文场景） */
        word-break: keep-all !important;
        .star-icon {
          width: 3.75rem;
          height: 3.75rem;
          margin-right: 0.5rem;
        }
      }
    }

    .data-grid {
      width: 42.375rem;
      margin: 0 auto;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 1rem;
      margin-bottom: 1.5rem;

      .data-card {
        background: #ffffff;
        border-radius: 1rem;
        padding: 2.5rem 1.5rem;
        text-align: center;
        box-shadow: 0 0.25rem 1rem rgba(0, 0, 0, 0.05);

        .data-value {
          font-size: 3rem;
          font-weight: bold;
          color: #0074fc;
          margin-bottom: 0.75rem;
        }

        .data-label {
          font-size: 1.75rem;
          color: #666;
          margin-bottom: 2.3rem;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.25rem;

          /* 核心：强制不换行 */
          white-space: nowrap !important;
          /* 防止文字被拆分换行（中文场景） */
          word-break: keep-all !important;

          .info-icon-small {
            cursor: pointer;
            width: 2rem;
            height: 2rem;
            margin-left: 0.4rem;
            opacity: 0.6;
          }
        }

        .data-status {
          width: 16.5rem;
          height: 4.5rem;
          margin: auto;
          display: inline-block;
          font-size: 1.75rem;
          border-radius: 3.5rem;
          display: flex;
          align-items: center;
          justify-content: center;

          &.normal1 {
            background: #73d13e1a;
            color: #73d13e;
          }
          &.normal2 {
            background: #0074fc1a;
            color: #0074fc;
          }
          &.normal3 {
            background: #faad141a;
            color: #faad14;
          }
        }
      }
    }

    .advice-card {
      width: 42.375rem;
      margin: 0 auto;
      background: linear-gradient(135deg, #66b3ff 0%, #0074fc 100%);
      border-radius: 1.25rem;
      padding: 2rem;
      margin-bottom: 1.5rem;
      color: #ffffff;

      .advice-title {
        font-size: 2rem;
        font-weight: 600;
        margin-bottom: 1rem;
      }

      .advice-disclaimer {
        font-size: 1.5rem;
        line-height: 1.6;
        opacity: 0.8;
        margin-bottom: 1.5rem;
      }

      .advice-list {
        .advice-item {
          display: flex;
          align-items: anchor-center;
          background: rgba(255, 255, 255, 0.15);
          border-radius: 1.5rem;
          padding: 1.5rem;
          margin-bottom: 1.5rem;
          font-weight: 400;
          font-size: 2rem;
          color: #ffffff;
          line-height: 3.1875rem;

          .advice-icon {
            width: 3rem;
            height: 3rem;
            margin-right: 1rem;
            flex-shrink: 0;
          }
        }
      }
    }

    .button-group {
      width: 42.375rem;
      margin: 0 auto;
      margin-bottom: 5rem;
      display: flex;
      gap: 1rem;

      .btn-download {
        flex: 1;
        width: 20.5rem;
        height: 6.5rem;
        background: #0074fc;
        border: none;
        border-radius: 1.5rem;
        color: #ffffff;
        font-size: 2.25rem;
        font-weight: 500;
        cursor: pointer;
        transition: background 0.2s;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;

        .download-icon {
          width: 3rem;
          height: 3rem;
        }

        &:hover {
          background: #0066e0;
        }

        &:active {
          background: #0058c0;
        }
      }

      .btn-recapture {
        flex: 1;
        width: 20.5rem;
        height: 6.5rem;
        background: #e8f4ff;
        border: none;
        border-radius: 1.5rem;
        color: #0074fc;
        font-size: 2.25rem;
        font-weight: 500;
        cursor: pointer;
        transition: background 0.2s;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;

        .refresh-icon {
          width: 3rem;
          height: 3rem;
        }

        &:hover {
          background: #d0e8ff;
        }

        &:active {
          background: #b8dcff;
        }
      }
    }
  }
}
</style>